declare global {
    interface Window {
        dataLayer: any[];
        gtag?: (...args: any[]) => void;
    }
}

const GA_ID = process.env.REACT_APP_GOOGLE_ANALYSIS_ID;
const GA_DISABLED = process.env.REACT_APP_GOOGLE_ANALYSIS_DISABLED === 'true';

let initialized = false;

export enum GA_EVENT_CATEGORY {
    Action = 'Action',
    User = 'User',
    Engagement = 'Engagement',
    Wallet = 'Wallet',
    Onboarding = 'Onboarding',
}

export enum GA_EVENT_ACTION {
    click_mint = 'click_mint',
    click_bind_social = 'click_bind_social',
    click_social_task = 'click_social_task',
    click_connect_wallet = 'click_connect_wallet',
    click_skip_invite = 'click_skip_invite',
    click_claim_gas = 'click_claim_gas',
}

export const initializeGA = (): void => {
    if (!GA_ID || GA_DISABLED || initialized || typeof window === 'undefined') return;

    // 插入 gtag.js 脚本
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script1);

    // 初始化 GA 配置
    const script2 = document.createElement('script');
    script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${GA_ID}');
    `;
    document.head.appendChild(script2);
    initialized = true;
};

interface EventParams {
    category: string;
    action: string;
    label?: string;
    value?: number;
}

export const trackEvent = ({ action, category, label, value }: EventParams): void => {
    if (GA_DISABLED || typeof window === 'undefined' || !window.gtag) return;

    window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value,
    });
};
